import * as React from "react";
import {
  Stack,
  Box,
  AppBar,
  Container,
  Button,
  IconButton,
  Typography,
  Drawer,
  List,
  ListItem,
  ListItemText,
  useMediaQuery,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { Multilanguage } from "./Multilanguage";
import { UserMenu } from "./commons/UserMenu.jsx";
import "../styles/AppBar.css";
import HomeIcon from "@mui/icons-material/Home";
import MenuIcon from "@mui/icons-material/Menu";
import HelpIcon from "@mui/icons-material/Help";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import logoAEC from "../images/logoAECFondoBlanco66x66.png";
import { useNavigate } from "react-router-dom";

const ResponsiveAppBar = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [isMenuOpen, setIsMenuOpen] = React.useState(false);
  const isMobile = useMediaQuery("(max-width: 960px)");

  function Home() {
    navigate("/");
  }

  function FAQs() {
    navigate("/FAQs");
  }

  function Glosario() {
    navigate("/Glosario-de-terminos");
  }

  const menuItems = [
    {
      label: t("nav.Inicio").toUpperCase(),
      icon: <HomeIcon sx={{ paddingRight: 1 }} />,
      onClick: Home,
    },
    {
      label: t("nav.FAQs").toUpperCase(),
      icon: <HelpIcon sx={{ paddingRight: 1 }} />,
      onClick: FAQs,
    },
    {
      label: t("nav.Glosario").toUpperCase(),
      icon: <MenuBookIcon sx={{ paddingRight: 1 }} />,
      onClick: Glosario,
    }
  ];

  return (
    <AppBar position="sticky">
      <Container>
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          spacing={{ xs: 2, lg: 8 }}
          sx={{
            minHeight: "75px",
          }}
        >
          <Stack
            direction={"row"}
            spacing={1}
            sx={{ display: { xs: "none", sm: "inherit" } }}
          >
            <a href="https://ipyme.org">
              <img
                src="https://paeelectronico.es/PublishingImages/Logo/Logo-Direccion-IPYME.png"
                className={"logo"}
                alt="Logo Direccion IPYME"
              />
            </a>
          </Stack>

          {isMobile ? (
            <Stack direction={"row"} alignItems={"center"} spacing={1}>
              <IconButton
                color="inherit"
                aria-label="Menu"
                onClick={() => setIsMenuOpen(true)}
              >
                <MenuIcon />
              </IconButton>

              <Drawer
                anchor="top"
                open={isMenuOpen}
                onClose={() => setIsMenuOpen(false)}
              >
                <Box
                  sx={{ bgcolor: "#005095", color: "white" }}
                  role="presentation"
                  onClick={() => setIsMenuOpen(false)}
                  onKeyDown={() => setIsMenuOpen(false)}
                >
                  <List>
                    {menuItems.map((item) => (
                      <ListItem
                        key={item.label}
                        onClick={item.onClick}
                      >
                        {item.icon}
                        <ListItemText primary={item.label} />
                      </ListItem>
                    ))}
                  </List>

                  {/* <Box sx={{ flexGrow: 1, zIndex: "99" }}>
                    <Multilanguage />
                  </Box>

                  <Box sx={{ flexGrow: 1, zIndex: "99" }}>
                    <UserMenu />
                  </Box> */}
                </Box>
              </Drawer>
              <Box sx={{ flexGrow: 1, zIndex: "99" }}>
                <Multilanguage />
              </Box>
              <Box sx={{ flexGrow: 1, zIndex: "99" }}>
                <UserMenu />
              </Box>
            </Stack>
          ) : (
            <Stack direction={"row"} alignItems={"center"} spacing={1}>
              <Box>
                <Button
                  onClick={() => {
                    Home();
                  }}
                  variant="text"
                  aria-label="Inicio"
                  color="text"
                >
                  <Stack
                    direction="row"
                    justifyContent="center"
                    alignItems="center"
                  >
                    <HomeIcon sx={{ color: "white" }} />
                    <Box>{t("nav.Inicio")}</Box>
                  </Stack>
                </Button>
              </Box>

              <Box sx={{ flexGrow: 0, zIndex: "99" }}>
                <Button
                  onClick={() => {
                    FAQs();
                  }}
                  variant="text"
                  aria-label="FAQs"
                  color="text"
                >
                  <Stack direction={"row"} spacing={1}>
                    <HelpIcon sx={{ color: "white" }} />
                    <Typography
                      sx={{ color: "white" }}
                      textAlign="center"
                    >
                      {t("nav.FAQs")}
                    </Typography>
                  </Stack>
                </Button>
              </Box>

              <Box sx={{ flexGrow: 0, zIndex: "99" }}>
                <Button
                  onClick={() => {
                    Glosario();
                  }}
                  variant="text"
                  aria-label="Glosario"
                  color="text"
                >
                  <Stack direction={"row"} spacing={1}>
                    <MenuBookIcon sx={{ color: "white" }} />
                    <Typography
                      sx={{ color: "white" }}
                      textAlign="center"
                    >
                      {t("nav.Glosario")}
                    </Typography>
                  </Stack>
                </Button>
              </Box>

              <Box sx={{ flexGrow: 0, zIndex: "99" }}>
                <Multilanguage />
              </Box>

              <Box sx={{ flexGrow: 0, zIndex: "99" }}>
                <UserMenu />
              </Box>
            </Stack>
          )}

          <Stack
            direction={"row"}
            spacing={1}
            sx={{ display: { xs: "none", sm: "inherit" } }}
          >
            <a href="/">
              <img
                src={logoAEC}
                className={"logoAEC"}
                alt="Autodiagnóstico Economia circular Logo"
              />
            </a>
          </Stack>
        </Stack>
      </Container>
    </AppBar>
  );
};
export default ResponsiveAppBar;

